import { startAlerta } from "../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../actions/ui/spinner";
import { fetchConToken } from "./fetch";
import { armarParametros } from "./parametros";

export const filterMultipleCondition = (items, conditions) => {
    return items.filter( (item) => {
        for (var key in conditions) {
          if (item[key] === undefined || item[key] !== conditions[key])
            return false;
        }
        return true;
    });
}

export const filterArrayFromArray = (array, secondArray) => {
    return array.filter(
        function(e) {
          return this.indexOf(e) < 0;
        },
        secondArray
    );
    
}

export const callConParametrosTurnos = async (dispatch, url, param, error) => {
    try{
        dispatch(startSpinner());
        const parametros = armarParametros(param.idEspecialidad, param.idCentroMedico, param.idProfesional);
        const response = await fetchConToken(`${url}${parametros}`);
        const contentType = response.headers.get("content-type");

        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (response.status !== 200) throw lista.errores;
            dispatch(finishSpinner());
            return lista
        }
        
    } catch (err){
        console.log("Function [callConParametrosTurnos]", err );
        dispatch(finishSpinner());
        dispatch(startAlerta(error, "warning", `¡Error!`));
    }
}

export const formatCurrencyPesos = (number) => {
    return new Intl.NumberFormat('es-AR', {
        style: "currency",
        currency: 'ARS'
    }).format(number);
}

export const formatSpError = (error = '') => {
    let formatError = error;
    formatError.errores = formatError.errores.replace(/No se pudo ejecutar el sp/g, '');
    formatError.errores = formatError.errores.substr(0, formatError.errores.indexOf('Line'));

    return formatError;
}